'use client'

import NextError from 'next/error'
import { useEffect } from 'react'

import { CrashReporter } from '@viziertronic/crash-reporter'

import { useBrowserRuntime } from '#runtime/browser.runtime.ts'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  const runtime = useBrowserRuntime()
  console.log('GlobalError', { error, stack: error.stack })
  useEffect(() => {
    runtime.runPromise(
      CrashReporter.use((cr) =>
        cr.report(error, {
          digest: error.digest,
        }),
      ),
    )
  }, [error, runtime])

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  )
}
